"use client";
import { getCookie } from "cookies-next/client";
import { getMeasurementAttribution } from "./ads-attribution-client";
import { validClickId } from "./attribution-storage";
import { getConsentChoice } from "./consent-client";

export const getFollowValues = () => {
  let gcid: string | undefined;
  let uetCookie: string | undefined;
  let gclid: string | undefined;
  // Google Anal
  if (getConsentChoice() === "all" && window.gaGlobal?.vid) {
    gcid = window.gaGlobal?.vid as string | undefined;
  }
  // Microsoft Ads
  const record = getMeasurementAttribution();
  const uetCookieValue = record.msclkid?.id ?? getCookie("t_msclkid");
  if (validClickId(uetCookieValue)) {
    uetCookie = uetCookieValue;
  }
  // Google Ads
  const gclidValue = record.gclid?.id ?? getCookie("t_gclid");
  if (validClickId(gclidValue)) {
    gclid = gclidValue;
  }

  return {
    gcid,
    uetCookie,
    gclid,
    gclid_captured_at: record.gclid ? String(record.gclid.at) : undefined,
    msclkid_captured_at: record.msclkid ? String(record.msclkid.at) : undefined,
  };
};
